import { SVGProps } from 'react';

const Accessibility = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m18 19 1-7-6 1M5 8l3-3 5.5 3-2.36 3.5m-6.9 3a5 5 0 0 0 6.88 6m2.64-3a5 5 0 0 0-6.88-6M17 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    />
  </svg>
);
export default Accessibility;
